import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';

import ErrorBoundary from 'components/Error/ErrorBoundary';
import ErrorMessage from 'components/Error/ErrorMessage';

import UsersState from 'context/Users/UsersState';

import 'assets/css/modules/Login/Login-module.css';

const Index = lazy(() => import('components/Login/Index'));

export default function Login(props) {
    return (
        <>
        <Helmet>
            <title>Acceder al Centro de Control - Conecta</title>
        </Helmet>
        <ErrorBoundary fallback={<ErrorMessage OnClick={() => document.location.reload()} fullPage />}>
            <Suspense fallback={<div style={{minHeight: '100vh', background: 'linear-gradient(90deg, #190C38, #3F246C)'}}></div>}>
                <UsersState>
                    <Index />
                </UsersState>
            </Suspense>
        </ErrorBoundary>
        </>
    )
}
